import React from 'react';
import { Link } from 'react-router-dom';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const SortableGridRow = ({ grid }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: grid.id });

  return (
    <tr
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1
      }}
      className='sortable-grid-row'
    >
      <td className='drag-handle-cell'>
        <div className='drag-handle' {...attributes} {...listeners}>
          ⋮
        </div>
      </td>
      <td className='title-cell'>{grid.title || '-'}</td>
      <td className='slug-cell'>{grid.slug || '-'}</td>
      <td className='published-cell'>{grid.published ? 'Yes' : 'No'}</td>
      <td className='actions-cell'>
        <Link to={`/recommendations/${grid.id}`} className='edit-button'>
          Edit
        </Link>
      </td>
    </tr>
  );
};
